enum FeaturedLengthType {
    OneMonth = "OneMonth",
    ThreeMonths = "ThreeMonths",
    SixMonths = "SixMonths",
    Custom = "Custom",
    NoEndDate = "NoEndDate"
}

export default FeaturedLengthType;